<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="131.674"
    height="161.284"
    viewBox="0 0 131.674 161.284"
  >
    <g
      id="Groupe_209"
      data-name="Groupe 209"
      transform="translate(-488.854 -1009.492)"
    >
      <path
        id="Tracé_178"
        data-name="Tracé 178"
        d="M-20943.666-16416.615s-122.187-2.275-120.121,143.774"
        transform="translate(21562.666 17427.617)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-width="3"
        stroke-dasharray="10"
      />
      <g
        id="Icons_fleches_outline_ic_arrow_down"
        data-name="Icons/fleches/outline/ic_arrow_down"
        transform="translate(488.854 1150.776)"
      >
        <path
          id="ic_dropdown_1"
          d="M10,7.907,17.475.433a1.48,1.48,0,0,1,2.092,0l-.544.544.544-.544a1.48,1.48,0,0,1,0,2.092l-8.521,8.521a1.48,1.48,0,0,1-2.092,0L.431,2.525A1.48,1.48,0,0,1,2.525.433Z"
          transform="translate(0 4.167)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "DashArrowLeft",
}
</script>
